"use client"

import { LanguageSwitcher } from "@/components/i18n/language-switcher"
import { useTheme } from "next-themes"
import { Sun, Moon } from "lucide-react"
import { useState, useEffect } from "react"

export function AuthActionsBar() {
  const { theme, setTheme } = useTheme()
  const [mounted, setMounted] = useState(false)
  useEffect(() => { setMounted(true) }, [])
  if (!mounted) return null
  return (
    <div className="fixed top-4 right-4 z-50 flex items-center gap-2 sm:gap-3">
      <LanguageSwitcher compact={true} />
      <button
        onClick={() => setTheme(theme === "dark" ? "light" : "dark")}
        className="p-2.5 rounded-full bg-white/90 dark:bg-white/10 backdrop-blur-lg border border-gray-200 dark:border-white/20 shadow-lg hover:scale-110 transition-transform"
        aria-label={theme === "dark" ? "Activer le mode clair" : "Activer le mode sombre"}
        type="button"
      >
        {theme === "dark" ? <Sun className="h-5 w-5" /> : <Moon className="h-5 w-5" />}
      </button>
    </div>
  )
}
